(function () {
  var STORAGE_KEY = "perfyra_delivery_location";
  var data = window.PerfyraLocationData || {};

  function deliveryLocationUrl() {
    var root = "/";
    try {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) {
        root = Shopify.routes.root;
      }
    } catch (e) {}
    if (root.slice(-1) !== "/") root += "/";
    return root + "pages/delivery-location";
  }

  function getLang(root) {
    return root && root.getAttribute("data-lang") === "ar" ? "ar" : "en";
  }

  function labelFor(item, lang) {
    if (!item) return "";
    if (typeof item === "string") return item;
    if (item.label) return item.label[lang] || item.label.en || "";
    if (item.name) return item.name[lang] || item.name.en || "";
    return "";
  }

  function clearOptions(select, placeholder) {
    if (!select) return;
    select.innerHTML = "";
    var option = document.createElement("option");
    option.value = "";
    option.textContent = placeholder || "";
    select.appendChild(option);
  }

  function syncSelectState(select) {
    if (!select) return;
    select.classList.toggle("has-value", !!select.value);
  }

  function readSaved() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    } catch (e) {
      return {};
    }
  }

  function saveSelection(payload) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload || {}));
  }

  function fieldValue(root, selector) {
    var el = root.querySelector(selector);
    return el ? String(el.value || "").trim() : "";
  }

  function sanitizeText(value, maxLen) {
    return String(value || "")
      .replace(/[\u0000-\u001F\u007F]/g, "")
      .replace(/[<>]/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, maxLen || 120);
  }

  function sanitizeName(value) {
    var clean = sanitizeText(value, 60);
    try {
      return clean.replace(/[^\p{L}\p{M}\s'\-.]/gu, "");
    } catch (e) {
      return clean.replace(/[^A-Za-z\u0600-\u06FF\s'\-.]/g, "");
    }
  }

  function sanitizeAddress(value) {
    var clean = sanitizeText(value, 120);
    try {
      return clean.replace(/[^\p{L}\p{M}\p{N}\s'\-.,/#&()]/gu, "");
    } catch (e) {
      return clean.replace(/[^A-Za-z0-9\u0600-\u06FF\s'\-.,/#&()]/g, "");
    }
  }

  function sanitizePhoneLocal(value) {
    return String(value || "").replace(/[^\d]/g, "").slice(0, 15);
  }

  function allowedDialCodes() {
    var codes = {};
    Object.keys(data).forEach(function (key) {
      if (data[key] && data[key].dialCode) codes[data[key].dialCode] = key;
    });
    return codes;
  }

  function phoneRulesFor(dialCode) {
    var map = {
      "+971": { min: 9, max: 9 },
      "+966": { min: 9, max: 9 },
      "+965": { min: 8, max: 8 },
      "+974": { min: 8, max: 8 },
      "+973": { min: 8, max: 8 },
      "+968": { min: 8, max: 8 },
      "+962": { min: 8, max: 9 }
    };
    return map[dialCode] || { min: 7, max: 12 };
  }

  function sanitizeShortAddress(value) {
    return String(value || "")
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "")
      .slice(0, 8);
  }

  function isValidShortAddress(value) {
    return /^[A-Z]{4}[0-9]{4}$/.test(String(value || ""));
  }

  function getSelection(root) {
    return {
      countryCode: fieldValue(root, "[data-pf-country]"),
      city: fieldValue(root, "[data-pf-city]"),
      area: fieldValue(root, "[data-pf-area]"),
      firstName: fieldValue(root, "[data-pf-first-name]"),
      lastName: fieldValue(root, "[data-pf-last-name]"),
      address1: fieldValue(root, "[data-pf-address1]"),
      phoneCode: fieldValue(root, "[data-pf-phone-code]"),
      phone: fieldValue(root, "[data-pf-phone]"),
      shortAddress: fieldValue(root, "[data-pf-short-address]")
    };
  }

  function sanitizeSelection(selection) {
    var dials = allowedDialCodes();
    var countryCode = String(selection.countryCode || "").toUpperCase();
    if (!data[countryCode]) countryCode = "";

    var city = sanitizeText(selection.city, 80);
    var area = sanitizeText(selection.area, 80);
    var country = countryCode ? data[countryCode] : null;
    if (!country || !country.cities || !country.cities[city]) {
      city = "";
      area = "";
    } else if ((country.cities[city].areas || []).indexOf(area) === -1) {
      area = "";
    }

    var phoneCode = String(selection.phoneCode || "").trim();
    if (!dials[phoneCode]) phoneCode = country && country.dialCode ? country.dialCode : "";

    var shortAddress = sanitizeShortAddress(selection.shortAddress);
    if (countryCode !== "SA") shortAddress = "";

    return {
      countryCode: countryCode,
      city: city,
      area: area,
      firstName: sanitizeName(selection.firstName),
      lastName: sanitizeName(selection.lastName),
      address1: sanitizeAddress(selection.address1),
      phoneCode: phoneCode,
      phone: sanitizePhoneLocal(selection.phone),
      shortAddress: shortAddress
    };
  }

  function toggleSaudiShortAddress(root, countryCode) {
    var wrap = root.querySelector("[data-pf-sa-only]");
    var input = root.querySelector("[data-pf-short-address]");
    if (!wrap) return;
    var show = String(countryCode || "").toUpperCase() === "SA";
    wrap.hidden = !show;
    if (input) {
      input.required = show;
      if (!show) {
        input.value = "";
        setFieldError(root, "shortAddress", "");
      }
    }
  }

  function fullPhone(selection) {
    var local = sanitizePhoneLocal(selection.phone);
    var code = String(selection.phoneCode || "").trim();
    if (!local || !code || !allowedDialCodes()[code]) return "";
    var codeDigits = code.replace("+", "");
    if (local.indexOf(codeDigits) === 0) local = local.slice(codeDigits.length);
    if (local.charAt(0) === "0") local = local.slice(1);
    return code + local;
  }

  function setFieldError(root, fieldName, message) {
    var field = root.querySelector('[data-pf-field="' + fieldName + '"]');
    if (!field) return;
    var errorNode = field.querySelector("[data-pf-field-error]");
    var input = field.querySelector(".pf-co__input");
    if (message) {
      field.classList.add("is-invalid");
      if (input) input.setAttribute("aria-invalid", "true");
      if (errorNode) {
        errorNode.hidden = false;
        errorNode.textContent = message;
      }
    } else {
      field.classList.remove("is-invalid");
      if (input) input.removeAttribute("aria-invalid");
      if (errorNode) {
        errorNode.hidden = true;
        errorNode.textContent = "";
      }
    }
  }

  function clearAllFieldErrors(root) {
    root.querySelectorAll("[data-pf-field]").forEach(function (field) {
      var name = field.getAttribute("data-pf-field");
      if (name) setFieldError(root, name, "");
    });
  }

  function msg(root, key, fallback) {
    return root.getAttribute(key) || fallback;
  }

  function populatePhoneCodes(root) {
    var codeSelect = root.querySelector("[data-pf-phone-code]");
    if (!codeSelect) return;
    var current = codeSelect.value;
    codeSelect.innerHTML = "";
    Object.keys(data).forEach(function (code) {
      var country = data[code];
      if (!country || !country.dialCode) return;
      var option = document.createElement("option");
      option.value = country.dialCode;
      option.textContent = (country.flag ? country.flag + " " : "") + country.dialCode;
      codeSelect.appendChild(option);
    });
    if (current) codeSelect.value = current;
    syncSelectState(codeSelect);
  }

  function syncPhoneCode(root, countryCode, preferredCode) {
    var codeSelect = root.querySelector("[data-pf-phone-code]");
    if (!codeSelect) return;
    if (!codeSelect.options.length) populatePhoneCodes(root);
    var dial = preferredCode || "";
    if (!dial && countryCode && data[countryCode] && data[countryCode].dialCode) {
      dial = data[countryCode].dialCode;
    }
    if (dial) {
      codeSelect.value = dial;
      syncSelectState(codeSelect);
    }
  }

  function fillTextFields(root, saved) {
    var map = {
      "[data-pf-first-name]": saved.firstName,
      "[data-pf-last-name]": saved.lastName,
      "[data-pf-address1]": saved.address1,
      "[data-pf-phone]": saved.phone,
      "[data-pf-short-address]": saved.shortAddress
    };
    Object.keys(map).forEach(function (selector) {
      var el = root.querySelector(selector);
      if (el && map[selector]) el.value = map[selector];
    });
    if (saved.phoneCode) syncPhoneCode(root, "", saved.phoneCode);
  }

  function showError(root, message) {
    var errorNode = root.querySelector("[data-pf-error]");
    if (!errorNode) return;
    if (!message) {
      errorNode.hidden = true;
      errorNode.textContent = "";
      return;
    }
    errorNode.hidden = false;
    errorNode.textContent = message;
  }

  function setCountryValue(root, code) {
    var country = root.querySelector("[data-pf-country]");
    if (country) country.value = code || "";
    syncSelectState(country);

    root.querySelectorAll("[data-pf-country-btn]").forEach(function (btn) {
      btn.classList.toggle("is-active", btn.getAttribute("data-pf-country-btn") === code);
    });
  }

  function populateCountryList(root) {
    var list = root.querySelector("[data-pf-country-list]");
    var lang = getLang(root);
    if (!list) return;

    list.innerHTML = "";
    Object.keys(data).forEach(function (code) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "pf-delivery-page__country-btn";
      btn.setAttribute("data-pf-country-btn", code);
      btn.textContent = labelFor(data[code], lang) || code;
      btn.addEventListener("click", function () {
        showError(root, "");
        setCountryValue(root, code);
        populateCities(root);
        saveSelection(getSelection(root));
      });
      list.appendChild(btn);
    });
  }

  function populateCountriesSelect(root) {
    var lang = getLang(root);
    var countrySelect = root.querySelector("select[data-pf-country]");
    if (!countrySelect) return;

    var placeholder = countrySelect.options[0]
      ? countrySelect.options[0].textContent
      : "Select country";
    clearOptions(countrySelect, placeholder);
    Object.keys(data).forEach(function (code) {
      var option = document.createElement("option");
      option.value = code;
      option.textContent = labelFor(data[code], lang) || code;
      countrySelect.appendChild(option);
    });
    syncSelectState(countrySelect);
  }

  function populateCities(root, selectedCity, selectedArea) {
    var citySelect = root.querySelector("[data-pf-city]");
    var areaSelect = root.querySelector("[data-pf-area]");
    var countryInput = root.querySelector("[data-pf-country]");
    if (!citySelect || !areaSelect || !countryInput) return;

    var cityPlaceholder = citySelect.options[0]
      ? citySelect.options[0].textContent
      : "Select city";
    var areaPlaceholder = areaSelect.options[0]
      ? areaSelect.options[0].textContent
      : "Select area";

    clearOptions(citySelect, cityPlaceholder);
    clearOptions(areaSelect, areaPlaceholder);
    areaSelect.disabled = true;
    syncSelectState(areaSelect);

    var country = data[countryInput.value];
    if (!country) {
      citySelect.disabled = true;
      syncSelectState(citySelect);
      return;
    }

    citySelect.disabled = false;
    Object.keys(country.cities || {}).forEach(function (cityKey) {
      var option = document.createElement("option");
      option.value = cityKey;
      option.textContent = labelFor(country.cities[cityKey], getLang(root)) || cityKey;
      citySelect.appendChild(option);
    });

    if (selectedCity && country.cities[selectedCity]) {
      citySelect.value = selectedCity;
      populateAreas(root, selectedArea);
    }
    syncSelectState(citySelect);
  }

  function populateAreas(root, selectedArea) {
    var citySelect = root.querySelector("[data-pf-city]");
    var areaSelect = root.querySelector("[data-pf-area]");
    var countryInput = root.querySelector("[data-pf-country]");
    if (!citySelect || !areaSelect || !countryInput) return;

    var areaPlaceholder = areaSelect.options[0]
      ? areaSelect.options[0].textContent
      : "Select area";
    clearOptions(areaSelect, areaPlaceholder);

    var country = data[countryInput.value];
    var city = country && country.cities ? country.cities[citySelect.value] : null;
    if (!city) {
      areaSelect.disabled = true;
      syncSelectState(areaSelect);
      return;
    }

    areaSelect.disabled = false;
    (city.areas || []).forEach(function (areaName) {
      var option = document.createElement("option");
      option.value = areaName;
      option.textContent = areaName;
      areaSelect.appendChild(option);
    });

    if (selectedArea) areaSelect.value = selectedArea;
    syncSelectState(areaSelect);
  }

  function bindDiscount(root) {
    // Discount is applied later on Shopify checkout.
  }

  function bindRoot(root) {
    var citySelect = root.querySelector("[data-pf-city]");
    var areaSelect = root.querySelector("[data-pf-area]");
    var countrySelect = root.querySelector("select[data-pf-country]");
    var completeBtn = root.querySelector("[data-pf-complete-order]");
    if (!citySelect || !areaSelect) return;

    if (root.querySelector("[data-pf-country-list]")) {
      populateCountryList(root);
    } else if (countrySelect) {
      populateCountriesSelect(root);
    }

    populatePhoneCodes(root);

    var saved = readSaved();
    fillTextFields(root, saved);

    var storeCountry = (root.getAttribute("data-default-country") || "").toUpperCase();
    var countryCode = "";
    var selectedCity = "";
    var selectedArea = "";

    if (storeCountry && data[storeCountry]) {
      countryCode = storeCountry;
      if (saved.countryCode === storeCountry) {
        selectedCity = saved.city || "";
        selectedArea = saved.area || "";
      }
    } else if (saved.countryCode && data[saved.countryCode]) {
      countryCode = saved.countryCode;
      selectedCity = saved.city || "";
      selectedArea = saved.area || "";
    }

    if (countryCode) {
      setCountryValue(root, countryCode);
      if (countrySelect) countrySelect.value = countryCode;
      populateCities(root, selectedCity, selectedArea);
      toggleSaudiShortAddress(root, countryCode);
      if (!(saved.phoneCode && saved.countryCode === countryCode)) {
        syncPhoneCode(root, countryCode);
      } else {
        syncPhoneCode(root, countryCode, saved.phoneCode);
      }
      saveSelection(sanitizeSelection(getSelection(root)));
    } else {
      syncPhoneCode(root, storeCountry);
      toggleSaudiShortAddress(root, storeCountry);
    }

    if (countrySelect) {
      countrySelect.addEventListener("change", function () {
        showError(root, "");
        clearAllFieldErrors(root);
        syncSelectState(countrySelect);
        populateCities(root);
        syncPhoneCode(root, countrySelect.value);
        toggleSaudiShortAddress(root, countrySelect.value);
        saveSelection(sanitizeSelection(getSelection(root)));
      });
    }

    citySelect.addEventListener("change", function () {
      showError(root, "");
      setFieldError(root, "city", "");
      setFieldError(root, "area", "");
      syncSelectState(citySelect);
      populateAreas(root);
      saveSelection(sanitizeSelection(getSelection(root)));
    });

    areaSelect.addEventListener("change", function () {
      showError(root, "");
      setFieldError(root, "area", "");
      syncSelectState(areaSelect);
      saveSelection(sanitizeSelection(getSelection(root)));
    });

    var phoneInput = root.querySelector("[data-pf-phone]");
    if (phoneInput) {
      phoneInput.addEventListener("input", function () {
        phoneInput.value = sanitizePhoneLocal(phoneInput.value);
        setFieldError(root, "phone", "");
      });
    }

    var shortInput = root.querySelector("[data-pf-short-address]");
    if (shortInput) {
      shortInput.addEventListener("input", function () {
        shortInput.value = sanitizeShortAddress(shortInput.value);
        setFieldError(root, "shortAddress", "");
        saveSelection(sanitizeSelection(getSelection(root)));
      });
      shortInput.addEventListener("blur", function () {
        var selection = sanitizeSelection(getSelection(root));
        if (selection.countryCode === "SA" && selection.shortAddress && !isValidShortAddress(selection.shortAddress)) {
          setFieldError(
            root,
            "shortAddress",
            msg(
              root,
              "data-err-short",
              "Please enter 4 English letters followed by 4 numbers, for example: RQNA8818."
            )
          );
        }
      });
    }

    root.querySelectorAll("[data-pf-first-name], [data-pf-last-name], [data-pf-address1], [data-pf-phone], [data-pf-phone-code], [data-pf-short-address]").forEach(function (input) {
      input.addEventListener("change", function () {
        if (input.matches("[data-pf-phone-code]")) {
          syncSelectState(input);
          setFieldError(root, "phoneCode", "");
        }
        if (input.matches("[data-pf-last-name]")) setFieldError(root, "lastName", "");
        if (input.matches("[data-pf-address1]")) setFieldError(root, "address1", "");
        if (input.matches("[data-pf-first-name]")) setFieldError(root, "firstName", "");
        saveSelection(sanitizeSelection(getSelection(root)));
      });
      input.addEventListener("blur", function () {
        saveSelection(sanitizeSelection(getSelection(root)));
      });
    });

    if (completeBtn) {
      completeBtn.addEventListener("click", function () {
        goToCheckoutFromRoot(root);
      });
    }

    bindDiscount(root);
  }

  function validateRoot(root) {
    clearAllFieldErrors(root);
    var selection = sanitizeSelection(getSelection(root));
    var firstInvalid = null;
    var ok = true;

    function fail(field, message) {
      ok = false;
      setFieldError(root, field, message);
      if (!firstInvalid) firstInvalid = root.querySelector('[data-pf-field="' + field + '"] .pf-co__input');
    }

    if (!selection.countryCode || !data[selection.countryCode]) {
      fail("country", msg(root, "data-err-country", "Please select a country."));
    }

    if (!selection.lastName || selection.lastName.length < 2) {
      fail("lastName", msg(root, "data-err-last", "Last name is required."));
    }

    if (!selection.address1 || selection.address1.length < 3) {
      fail("address1", msg(root, "data-err-address", "Address is required."));
    }

    if (!selection.city) {
      fail("city", msg(root, "data-err-city", "Please select a city."));
    }

    if (!selection.area) {
      fail("area", msg(root, "data-err-area", "Please select an area."));
    }

    if (!selection.phoneCode || !allowedDialCodes()[selection.phoneCode]) {
      fail("phoneCode", msg(root, "data-err-phone-code", "Please select a country code."));
    }

    var rules = phoneRulesFor(selection.phoneCode);
    var phoneDigits = selection.phone;
    if (phoneDigits.charAt(0) === "0") phoneDigits = phoneDigits.slice(1);
    if (!phoneDigits || phoneDigits.length < rules.min || phoneDigits.length > rules.max) {
      fail("phone", msg(root, "data-err-phone", "Please enter a valid phone number."));
    }

    if (selection.countryCode === "SA" && !isValidShortAddress(selection.shortAddress)) {
      fail(
        "shortAddress",
        msg(
          root,
          "data-err-short",
          "Please enter 4 English letters followed by 4 numbers, for example: RQNA8818."
        )
      );
    }

    if (!ok) {
      showError(root, msg(root, "data-error", "Please fix the highlighted fields before continuing."));
      if (firstInvalid && typeof firstInvalid.focus === "function") firstInvalid.focus();
      return { valid: false, selection: selection };
    }

    var map = {
      "[data-pf-first-name]": selection.firstName,
      "[data-pf-last-name]": selection.lastName,
      "[data-pf-address1]": selection.address1,
      "[data-pf-phone]": phoneDigits,
      "[data-pf-phone-code]": selection.phoneCode,
      "[data-pf-short-address]": selection.shortAddress
    };
    Object.keys(map).forEach(function (selector) {
      var el = root.querySelector(selector);
      if (el) el.value = map[selector];
    });
    selection.phone = phoneDigits;

    showError(root, "");
    saveSelection(selection);
    return { valid: true, selection: selection };
  }

  function buildCheckoutUrl(selection) {
    var clean = sanitizeSelection(selection);
    var country = data[clean.countryCode];
    if (!country) return "/checkout";

    var params = new URLSearchParams();
    if (clean.firstName) params.set("checkout[shipping_address][first_name]", clean.firstName);
    if (clean.lastName) params.set("checkout[shipping_address][last_name]", clean.lastName);
    if (clean.address1) params.set("checkout[shipping_address][address1]", clean.address1);

    var phone = fullPhone(clean);
    if (phone) params.set("checkout[shipping_address][phone]", phone);

    params.set("checkout[shipping_address][country]", country.countryCode || clean.countryCode);
    params.set("checkout[shipping_address][city]", clean.city);
    params.set("checkout[shipping_address][address2]", clean.area);
    // Never send National Short Address to zip/postal_code.
    // Leave postal code empty unless a valid 5-digit Saudi postal code is provided separately.
    if (clean.countryCode === "AE") {
      params.set("checkout[shipping_address][province]", clean.city);
    }
    return "/checkout?" + params.toString();
  }

  function saveCartAttributes(selection) {
    var clean = sanitizeSelection(selection);
    var attributes = {
      Delivery_Country: clean.countryCode,
      Delivery_City: clean.city,
      Delivery_Area: clean.area,
      Delivery_Phone: fullPhone(clean),
      "National Short Address": clean.countryCode === "SA" ? clean.shortAddress : "",
      "Saudi Short Code": "",
      "National short address": ""
    };

    return fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () {
      return null;
    });
  }

  function goToCheckoutFromRoot(root) {
    var completeBtn = root.querySelector("[data-pf-complete-order]");
    if (completeBtn && completeBtn.dataset.pfBusy === "1") return;

    var result = validateRoot(root);
    if (!result.valid) return;

    if (completeBtn) {
      completeBtn.dataset.pfBusy = "1";
      completeBtn.disabled = true;
    }

    saveCartAttributes(result.selection).finally(function () {
      // Prefill shipping fields, but never send National Short Address to zip/postal_code.
      window.location.href = buildCheckoutUrl(result.selection);
    });
  }

  function goToDeliveryPage(event) {
    event.preventDefault();
    event.stopPropagation();
    window.location.href = deliveryLocationUrl();
    return false;
  }

  function bindCheckoutButtons() {
    // On delivery page: page CTA handles checkout.
    if (document.querySelector("[data-pf-location-page]")) return;

    function redirectToDelivery(event) {
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      window.location.assign(deliveryLocationUrl());
      return false;
    }

    function isDeliveryLink(el) {
      if (!el || el.tagName !== "A") return false;
      var href = el.getAttribute("href") || "";
      return href.indexOf("delivery-location") !== -1;
    }

    document.querySelectorAll('button[name="checkout"], #checkout-submit, a[href="/checkout"], a[href$="/checkout"], a[href*="/checkouts/"]').forEach(function (el) {
      // Links already pointing to delivery-location should navigate normally.
      if (isDeliveryLink(el)) {
        el.addEventListener(
          "click",
          function (event) {
            // Ensure navigation even if other handlers call preventDefault.
            var href = el.getAttribute("href");
            if (!href) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            window.location.assign(href);
          },
          true
        );
        return;
      }
      el.addEventListener("click", redirectToDelivery, true);
    });

    document.querySelectorAll("form[action='/cart'], form[action*='/cart']").forEach(function (form) {
      form.addEventListener(
        "submit",
        function (event) {
          var submitter = event.submitter;
          if (submitter && submitter.getAttribute("name") === "checkout") {
            redirectToDelivery(event);
          }
        },
        true
      );
    });
  }

  function init() {
    document.querySelectorAll("[data-pf-location-selector]").forEach(bindRoot);
    bindCheckoutButtons();
  }

  document.addEventListener("DOMContentLoaded", init);

  window.PerfyraLocationSelector = {
    validateRoot: validateRoot,
    getSelection: function () {
      return readSaved();
    }
  };
})();
